import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AlertState, ApplicationState, MapPopupState } from 'types/types';

const initialState: ApplicationState = {
  toggle: false,
  toggleCount: 0,
  notificationToggle: false,
  formDirtyState: false,
  applicationSettings: {
    BING_MAP_API_KEY: '',
    AUTHENTICATION_TYPE: '',
    HELP_LINK: '',
    FIRST_DAY_OF_WEEK: '',
    WEEK_CALC_RULE: '',
    MAX_VIEWS_OPEN: '',
    ENABLE_EXPORT_COMPRESSION: '',
    MAX_HIERARCHIES_LIMIT: '',
    CORRELATION_CONGESTION_ENABLED: false,
    DEFAULT_DATE_FORMAT: '',
    CHART_AXIS_CONFIG: [],
    PRODUCT_VERSION: '',
    RELEASE_NOTES_LINK: '',
    SESSION_TIMEOUT: '3600', // 1 hours default session timeout
    ALARM_MAX_NUMBER_OF_ALARMS: 0,
    ALARM_MAX_NUMBER_OF_DISTINCT_RULE_ELEMENTS: 0,
    ALARM_RETENTIONEXECUTIONLOGS_NUMBEROFPERIODS: {
      '15min': 0,
      DEFAULT: 0,
      hourly: 0,
    },
  },
  alert: {
    severity: 'success',
    title: '',
    message: '',
    open: false,
  },
  sidebarItems: [],
  openedViews: [],
  searchText: '',
  activeView: { appName: '...', viewId: '...' },
  mapPopupState: {
    isVisible: false,
    getGeoJsonCallback: () => null,
    geoJson: null,
    region: null,
  },
};

const applicationStateSlice = createSlice({
  name: 'applicationState',
  initialState,
  reducers: {
    toggleMenu: (state) => {
      state.toggle = !state.toggle;
      state.toggleCount += 1;
      state.searchText = '';
    },
    showMenu: (state) => {
      state.toggle = true;
    },
    updateApplicationSettings: (state, action) => {
      state.applicationSettings = action.payload;
    },
    toggleNotification: (state) => {
      state.notificationToggle = !state.notificationToggle;
    }, 
    updateDirtyState: (state, action) => {
      state.formDirtyState = action.payload;
    },
    showAlert: (state, action: PayloadAction<AlertState>) => {
      state.alert = action.payload;
    },
    hideAlert: (state) => {
      state.alert.open = false;
    },

    updateSidebarItems: (state, action) => {
      state.sidebarItems = action.payload;
    },
    setOpenedViews: (state, action: PayloadAction<any[]>) => {
      state.openedViews = action.payload;
    },
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
    setActiveView: (state, action) => {
      const { viewId, value, text, title, properties, type } = action.payload;
      state.activeView = {
        value,
        viewId,
        text,
        title,
        properties,
        type,
      };
    },
    setMapPopupState: (state, action: PayloadAction<MapPopupState>) => {
      state.mapPopupState = action.payload;
    },
  },
});

export const {
  toggleMenu,
  showMenu,
  updateApplicationSettings,
  toggleNotification,
  updateDirtyState,
  showAlert,
  hideAlert,
  updateSidebarItems,
  setOpenedViews,
  setSearchText,
  setActiveView,
  setMapPopupState,
} = applicationStateSlice.actions;
export default applicationStateSlice.reducer;
